import axios from 'axios';

const updateActiveHours = ({ url, ...params }) => {
  return axios.put(url, params);
};

export { updateActiveHours };
